import { createRoute, Outlet, redirect } from "@tanstack/solid-router";
import { isAdminCapable } from "@tendly/shared";
import { appRoute } from "./route";
import { sessionActor } from "@/lib/session-machine";
import { readAccountsStateSync } from "@/lib/accounts";
import { resolveActiveAccountView } from "@/lib/active-account";
import { activeTabAccountId } from "@/lib/tab-account";

export const adminRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/admin",
  beforeLoad: () => {
    const view = resolveActiveAccountView(
      readAccountsStateSync(),
      activeTabAccountId(),
      sessionActor.getSnapshot().context.session,
    );

    if (!isAdminCapable(view.role)) {
      // oxlint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: "/profile" });
    }
  },
  component: () => <Outlet />,
});
